import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=57104b84&scoped=true&"
import script from "./Region.vue?vue&type=script&lang=ts&"
export * from "./Region.vue?vue&type=script&lang=ts&"
import style0 from "./Region.vue?vue&type=style&index=0&id=57104b84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57104b84",
  null
  
)

export default component.exports